const GlobalData = {
  title: {
    pl: "Kalkulator ROI",
    en: "ROI calculator",
  },
  subtitle: {
    pl: "*ROI - wskaźnik oceny efektywności inwestycji",
    en: "*ROI - investment effectiveness assessment index",
  },
  nav: {
    step1: { pl: "Kategorie", en: "Categories" },
    step2: { pl: "Dane", en: "Data" },
    step3: { pl: "System Wizyjny", en: "Vision System" },
    step4: { pl: "Twoje ROI", en: "Your ROI" },
  },
  buttons: {
    back: { pl: "Wróć", en: "Return" },
    next: { pl: "Dalej", en: "Next" },
    backEdit: { pl: "Popraw dane", en: "Correct data" },
    send: { pl: "Wyślij raport", en: "Send report" },
    begin: { pl: "Zacznij od nowa", en: "Start again" },
  },
  placeholder: {
    number: { pl: "Wpisz liczbę", en: "Enter a number" },
    email: { pl: "Wpisz email", en: "Enter email" },
  },
  validation: {
    empty: {
      pl: "To pole nie może być puste",
      en: "This field must not be empty",
    },
    zero: {
      pl: "Wartość musi być większa od zera",
      en: "The value must be greater than zero",
    },
    email1: {
      pl: "Wpisz adres email",
      en: "Enter your email address",
    },
    email2: {
      pl: "Wpisano niepoprawny adres email",
      en: "Incorrect email address entered",
    },
  },
  modal: {
    text: {
      pl: "Kontynuowanie spowoduje usunięcie dotychczas wprowadzonych danych. Jeśli chcesz zachować dane, wybierz opcję “Popraw dane”. Jeśli chcesz kontynuować, wybierz opcję “Zacznij od nowa”.",
      en: 'Continuing will delete the data you have entered so far. If you want to keep the data, select "Correct data". If you wish to continue, select "Start again".',
    },
    warning: {
      pl: "OSTRZEŻENIE: ",
      en: "WARNING: ",
    },
  },
  month: {
    pl: "mies.",
    en: "month",
  },
};
export default GlobalData;
